import {BaseModel} from "../base/base.model";
import {IClientModel} from "../clients/clients.model";
import {NotesModel} from "../notes/notes.model";
import {BadgesModel} from "../badges/badges.model";

export class NotificationsModel extends BaseModel{
    message: string;
    room: string;
    unread: number;
    data: IClientModel|NotesModel|any;
    type: NotificationsType;
    badge: BadgesModel
}

export class NotificationsUnreadCountsModel extends BaseModel{
    channel: string;
    count: number;
}

export enum NotificationsType {
    CLIENT_STATUS_CHANGED = <any> 'client_status_changed',
    CLIENT_ASSIGNED = <any> 'client_assigned',
    CLIENT_REASSIGNED = <any> 'client_reassigned',
    NEW_NOTE_FOR_CLIENT = <any> 'new_note_for_client',
    SCHEDULED_CALLBACK_STARTS = <any> 'scheduled_callback_starts',
    SALES_NOTES_UPDATED = <any> 'sales_notes_updated',
    NEW_SALES_NOTE_COMMENT = <any> 'new_sales_note_comment',
}



// WEBPACK FOOTER //
// ./src/app/models/notifications/notifications.model.ts